import { createClient } from "tinacms/dist/client";
import { queries } from "./types";
export const client = createClient({ cacheDir: '/opt/buildhome/repo/web/tina/__generated__/.cache/1745952073385', url: 'https://content.tinajs.io/1.5/content/dac872ef-1f43-4f71-8513-1cb789e62a6f/github/main', token: '0cf558d6a957c7b66b6f567673da9e4219c56da8', queries,  });
export default client;
  